import React, { useState } from 'react';

const TermsModal = ({ isOpen: controlledOpen, onClose: controlledClose } = {}) => {
  const [internalOpen, setInternalOpen] = useState(false);
  // Controlled mode: parent passes isOpen/onClose. Uncontrolled: render our own
  // trigger button (the Footer use case). Both kept so existing call-sites that
  // dropped <TermsModal /> in keep working unchanged.
  const isControlled = controlledOpen !== undefined;
  const isOpen = isControlled ? controlledOpen : internalOpen;
  const close = isControlled
    ? () => controlledClose && controlledClose()
    : () => setInternalOpen(false);

  return (
    <>
      {!isControlled && (
        <button
          className="text-lg font-semibold mb-4 text-indigo-700 hover:text-indigo-900 transition"
          onClick={() => setInternalOpen(true)}
        >
          Termeni și Condiții
        </button>
      )}

      {isOpen && (
        <div
          className="fixed inset-0 flex items-center justify-center bg-black/60 z-[9999] backdrop-blur-sm animate-fadeIn"
          onClick={close}
        >
          <div
            className="relative bg-gradient-to-br from-white via-indigo-50 to-blue-50 p-8 rounded-2xl shadow-2xl w-11/12 max-w-lg mx-auto overflow-y-auto max-h-[80vh] border border-indigo-100 animate-slideUp"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close button */}
            <button
              className="absolute top-3 right-3 text-red-500 bg-white rounded-full shadow-lg p-2 hover:bg-red-50 hover:scale-110 transition z-10"
              onClick={close}
              aria-label="Închide"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>

            {/* Modal content */}
            <h2 className="text-2xl font-extrabold mb-6 text-indigo-800 text-center drop-shadow-sm">
              Termeni și Condiții
            </h2>
            <div className="space-y-5 text-base">
              <p className="text-gray-700">
                Acești termeni și condiții reglementează utilizarea platformei{' '}
                <span className="font-semibold text-indigo-700">
                  {import.meta.env.VITE_NAME}
                </span>
                , deținută de{' '}
                <span className="font-semibold text-indigo-700">
                  SC BIMART SOLUTIONS SRL
                </span>
                .
                <br />
                Prin accesarea și utilizarea platformei, sunteți de acord să
                respectați termenii și condițiile descrise mai jos.
              </p>
              <div className="bg-indigo-50 border-l-4 border-indigo-300 p-4 rounded-lg">
                <p className="font-bold text-indigo-700 mb-1">
                  1. Utilizarea Platformei
                </p>
                <p className="text-gray-700">
                  Platforma este destinată exclusiv utilizării în scopuri
                  legale. Orice utilizare abuzivă sau acces neautorizat este
                  strict interzisă.
                </p>
              </div>
              <div className="bg-indigo-50 border-l-4 border-indigo-300 p-4 rounded-lg">
                <p className="font-bold text-indigo-700 mb-1">
                  2. Proprietatea Intelectuală
                </p>
                <p className="text-gray-700">
                  Toate materialele prezente pe platformă, inclusiv texte,
                  imagini, logo-uri și coduri, sunt proprietatea SC BIMART
                  SOLUTIONS SRL. Este interzisă reproducerea, distribuirea sau
                  utilizarea acestora fără acordul scris al companiei.
                </p>
              </div>
              <div className="bg-indigo-50 border-l-4 border-indigo-300 p-4 rounded-lg">
                <p className="font-bold text-indigo-700 mb-1">
                  3. Limitarea Răspunderii
                </p>
                <p className="text-gray-700">
                  SC BIMART SOLUTIONS SRL nu poate fi trasă la răspundere pentru
                  eventualele daune sau pierderi rezultate din utilizarea
                  platformei.
                </p>
              </div>
              <div className="bg-indigo-50 border-l-4 border-indigo-300 p-4 rounded-lg">
                <p className="font-bold text-indigo-700 mb-1">
                  4. Modificarea Termenilor
                </p>
                <p className="text-gray-700">
                  SC BIMART SOLUTIONS SRL își rezervă dreptul de a modifica
                  termenii și condițiile fără notificare prealabilă. Orice
                  modificări vor fi publicate pe această pagină.
                </p>
              </div>
              <div className="bg-indigo-50 border-l-4 border-indigo-300 p-4 rounded-lg">
                <p className="font-bold text-indigo-700 mb-1">5. Contact</p>
                <p className="text-gray-700">
                  Pentru întrebări legate de termeni și condiții, ne puteți
                  contacta la:{' '}
                  <a
                    href="mailto:office@licitatii-constructii.ro"
                    className="font-mono text-indigo-700 underline hover:text-indigo-900"
                  >
                    office@licitatii-constructii.ro
                  </a>
                  .
                </p>
              </div>
            </div>
            {/* Close button inside modal */}
            <button
              className="bg-gradient-to-r from-indigo-600 to-blue-500 text-white font-semibold py-2 px-4 rounded-xl hover:from-indigo-700 hover:to-blue-600 focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2 mt-8 w-full shadow-lg transition"
              onClick={close}
            >
              Închide
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default TermsModal;
